// const host = "https://localhost:5002";
const host = "https://qpay.nblmt.com.my";

export const environment = {
  production: false,
  host: host,
  apiRoot: `${host}/api/v1`
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
